import gdp from 'gio-webjs-sdk-cdp/gdp-full';
import { getCurrentUid } from '../api/web-h5-common';
import { getChannel, getClientEnv, getQueryObj } from './common'

const accountIdMap = {
  'test': '89a922449121f7c2',
  'deploy': '89a922449121f7c2',
  'product': '84eafaa69d23412f'
}
const datasourceIdMap = {
  'test': 'ab792bc691554c4d',
  'deploy': 'ab792bc691554c4d',
  'product': 'bafd9e977149be4c'
}
const hostMap = {
  'test': 'collect.test.xiaopeng.com',
  'deploy': 'collect.test.xiaopeng.com',
  'product': 'collect.xiaopeng.com'
}

const accountId = accountIdMap[getClientEnv()]
const datasourceId = datasourceIdMap[getClientEnv()]
const defaultConfig = {
  host: hostMap[getClientEnv()],
  version: '1.0.0',
  autotrack: false, // 无埋点开关
  hashtags: true // 是否开启hashtag
}
const defaultParams = {
  user_channel: getChannel()
}
const eventPrefix = 'charge_H5'

export function initGdp(config?: object) {
  let queryObj = getQueryObj();

  if (queryObj.giodatacollect === 'true') {
    // 识别到是在小程序中，使用小程序的配置
    gdp('init', queryObj.gioprojectid, queryObj.giodatasourceid, queryObj.gioappid, Object.assign(defaultConfig, config));
  } else {
    gdp('init', accountId, datasourceId, Object.assign(defaultConfig, config));
  }

  console.log('gdp getOption', gdp('getOption'));

  if (process.env.NODE_ENV === 'development') {
    gdp('setOption', 'debug', true);
  }
}

export function trackGdp(pageId: string, buttonId: string, params?: object) {
  getCurrentUid().then(uid => {
    defaultParams['userId'] = uid
    defaultParams['user_id'] = uid

    gdp('setUserId', uid)
    gdp('track', `${eventPrefix}_${pageId}_${buttonId}`, {...defaultParams, ...params});
    console.log('===== 埋点上报完成 ======', `pageId: ${pageId} | buttonId: ${buttonId}`, `| 参数：${JSON.stringify({...defaultParams, ...params})}`)
  }).catch(() => {})
}